//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '3.8.2'.
//
package de.katoonerie.adapter

import com.apollographql.apollo3.api.Adapter
import com.apollographql.apollo3.api.AnyAdapter
import com.apollographql.apollo3.api.CustomScalarAdapters
import com.apollographql.apollo3.api.NullableStringAdapter
import com.apollographql.apollo3.api.json.JsonReader
import com.apollographql.apollo3.api.json.JsonWriter
import com.apollographql.apollo3.api.list
import com.apollographql.apollo3.api.nullable
import com.apollographql.apollo3.api.obj
import de.katoonerie.PageQuery
import kotlin.Any
import kotlin.String
import kotlin.Unit
import kotlin.collections.List

public object PageQuery_ResponseAdapter {
  public object Data : Adapter<PageQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("pageCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Data {
      var _pageCollection: PageQuery.PageCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _pageCollection = PageCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Data(
        pageCollection = _pageCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Data,
    ): Unit {
      writer.name("pageCollection")
      PageCollection.obj().nullable().toJson(writer, customScalarAdapters, value.pageCollection)
    }
  }

  public object PageCollection : Adapter<PageQuery.PageCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.PageCollection {
      var _items: List<PageQuery.Item?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.PageCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.PageCollection,
    ): Unit {
      writer.name("items")
      Item.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item : Adapter<PageQuery.Item> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "url", "navigationBar",
        "tilesCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item {
      var _name: String? = null
      var _url: String? = null
      var _navigationBar: PageQuery.NavigationBar? = null
      var _tilesCollection: PageQuery.TilesCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _navigationBar = NavigationBar.obj().nullable().fromJson(reader,
              customScalarAdapters)
          3 -> _tilesCollection = TilesCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item(
        name = _name,
        url = _url,
        navigationBar = _navigationBar,
        tilesCollection = _tilesCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)

      writer.name("navigationBar")
      NavigationBar.obj().nullable().toJson(writer, customScalarAdapters, value.navigationBar)

      writer.name("tilesCollection")
      TilesCollection.obj().nullable().toJson(writer, customScalarAdapters, value.tilesCollection)
    }
  }

  public object NavigationBar : Adapter<PageQuery.NavigationBar> {
    public val RESPONSE_NAMES: List<String> = listOf("navigationItemsCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.NavigationBar {
      var _navigationItemsCollection: PageQuery.NavigationItemsCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _navigationItemsCollection = NavigationItemsCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.NavigationBar(
        navigationItemsCollection = _navigationItemsCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.NavigationBar,
    ): Unit {
      writer.name("navigationItemsCollection")
      NavigationItemsCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.navigationItemsCollection)
    }
  }

  public object NavigationItemsCollection : Adapter<PageQuery.NavigationItemsCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.NavigationItemsCollection {
      var _items: List<PageQuery.Item1?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item1.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.NavigationItemsCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.NavigationItemsCollection,
    ): Unit {
      writer.name("items")
      Item1.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item1 : Adapter<PageQuery.Item1> {
    public val RESPONSE_NAMES: List<String> = listOf("tile", "color", "icon")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item1 {
      var _tile: PageQuery.Tile? = null
      var _color: PageQuery.Color? = null
      var _icon: PageQuery.Icon? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _tile = Tile.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _color = Color.obj().nullable().fromJson(reader, customScalarAdapters)
          2 -> _icon = Icon.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item1(
        tile = _tile,
        color = _color,
        icon = _icon
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item1,
    ): Unit {
      writer.name("tile")
      Tile.obj().nullable().toJson(writer, customScalarAdapters, value.tile)

      writer.name("color")
      Color.obj().nullable().toJson(writer, customScalarAdapters, value.color)

      writer.name("icon")
      Icon.obj().nullable().toJson(writer, customScalarAdapters, value.icon)
    }
  }

  public object Tile : Adapter<PageQuery.Tile> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "slug")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Tile {
      var _name: String? = null
      var _slug: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _slug = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Tile(
        name = _name,
        slug = _slug
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Tile,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("slug")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.slug)
    }
  }

  public object Color : Adapter<PageQuery.Color> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Color {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Color(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Color,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Icon : Adapter<PageQuery.Icon> {
    public val RESPONSE_NAMES: List<String> = listOf("url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Icon {
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Icon(
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Icon,
    ): Unit {
      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object TilesCollection : Adapter<PageQuery.TilesCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.TilesCollection {
      var _items: List<PageQuery.Item2?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item2.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.TilesCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.TilesCollection,
    ): Unit {
      writer.name("items")
      Item2.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item2 : Adapter<PageQuery.Item2> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "slug", "color", "layout", "media",
        "body", "gimmicksCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item2 {
      var _name: String? = null
      var _slug: String? = null
      var _color: PageQuery.Color1? = null
      var _layout: PageQuery.Layout? = null
      var _media: PageQuery.Media? = null
      var _body: PageQuery.Body? = null
      var _gimmicksCollection: PageQuery.GimmicksCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _slug = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _color = Color1.obj().nullable().fromJson(reader, customScalarAdapters)
          3 -> _layout = Layout.obj().nullable().fromJson(reader, customScalarAdapters)
          4 -> _media = Media.obj().nullable().fromJson(reader, customScalarAdapters)
          5 -> _body = Body.obj().nullable().fromJson(reader, customScalarAdapters)
          6 -> _gimmicksCollection = GimmicksCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item2(
        name = _name,
        slug = _slug,
        color = _color,
        layout = _layout,
        media = _media,
        body = _body,
        gimmicksCollection = _gimmicksCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item2,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("slug")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.slug)

      writer.name("color")
      Color1.obj().nullable().toJson(writer, customScalarAdapters, value.color)

      writer.name("layout")
      Layout.obj().nullable().toJson(writer, customScalarAdapters, value.layout)

      writer.name("media")
      Media.obj().nullable().toJson(writer, customScalarAdapters, value.media)

      writer.name("body")
      Body.obj().nullable().toJson(writer, customScalarAdapters, value.body)

      writer.name("gimmicksCollection")
      GimmicksCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.gimmicksCollection)
    }
  }

  public object Color1 : Adapter<PageQuery.Color1> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Color1 {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Color1(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Color1,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Layout : Adapter<PageQuery.Layout> {
    public val RESPONSE_NAMES: List<String> = listOf("type")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Layout {
      var _type: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _type = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Layout(
        type = _type
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Layout,
    ): Unit {
      writer.name("type")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.type)
    }
  }

  public object Media : Adapter<PageQuery.Media> {
    public val RESPONSE_NAMES: List<String> = listOf("youTubeVideosCollection", "mediaCollection")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Media {
      var _youTubeVideosCollection: PageQuery.YouTubeVideosCollection? = null
      var _mediaCollection: PageQuery.MediaCollection? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _youTubeVideosCollection = YouTubeVideosCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          1 -> _mediaCollection = MediaCollection.obj().nullable().fromJson(reader,
              customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Media(
        youTubeVideosCollection = _youTubeVideosCollection,
        mediaCollection = _mediaCollection
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Media,
    ): Unit {
      writer.name("youTubeVideosCollection")
      YouTubeVideosCollection.obj().nullable().toJson(writer, customScalarAdapters,
          value.youTubeVideosCollection)

      writer.name("mediaCollection")
      MediaCollection.obj().nullable().toJson(writer, customScalarAdapters, value.mediaCollection)
    }
  }

  public object YouTubeVideosCollection : Adapter<PageQuery.YouTubeVideosCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.YouTubeVideosCollection {
      var _items: List<PageQuery.Item3?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item3.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.YouTubeVideosCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.YouTubeVideosCollection,
    ): Unit {
      writer.name("items")
      Item3.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item3 : Adapter<PageQuery.Item3> {
    public val RESPONSE_NAMES: List<String> = listOf("name", "videoId")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item3 {
      var _name: String? = null
      var _videoId: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _name = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _videoId = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item3(
        name = _name,
        videoId = _videoId
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item3,
    ): Unit {
      writer.name("name")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("videoId")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.videoId)
    }
  }

  public object MediaCollection : Adapter<PageQuery.MediaCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.MediaCollection {
      var _items: List<PageQuery.Item4?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item4.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.MediaCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.MediaCollection,
    ): Unit {
      writer.name("items")
      Item4.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item4 : Adapter<PageQuery.Item4> {
    public val RESPONSE_NAMES: List<String> = listOf("contentType", "title", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item4 {
      var _contentType: String? = null
      var _title: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _contentType = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _title = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item4(
        contentType = _contentType,
        title = _title,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item4,
    ): Unit {
      writer.name("contentType")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.contentType)

      writer.name("title")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object Body : Adapter<PageQuery.Body> {
    public val RESPONSE_NAMES: List<String> = listOf("mediaCollection", "textColor",
        "backgroundColor", "borderColor", "text")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Body {
      var _mediaCollection: PageQuery.MediaCollection1? = null
      var _textColor: PageQuery.TextColor? = null
      var _backgroundColor: PageQuery.BackgroundColor? = null
      var _borderColor: PageQuery.BorderColor? = null
      var _text: PageQuery.Text? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _mediaCollection = MediaCollection1.obj().nullable().fromJson(reader,
              customScalarAdapters)
          1 -> _textColor = TextColor.obj().nullable().fromJson(reader, customScalarAdapters)
          2 -> _backgroundColor = BackgroundColor.obj().nullable().fromJson(reader,
              customScalarAdapters)
          3 -> _borderColor = BorderColor.obj().nullable().fromJson(reader, customScalarAdapters)
          4 -> _text = Text.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Body(
        mediaCollection = _mediaCollection,
        textColor = _textColor,
        backgroundColor = _backgroundColor,
        borderColor = _borderColor,
        text = _text
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Body,
    ): Unit {
      writer.name("mediaCollection")
      MediaCollection1.obj().nullable().toJson(writer, customScalarAdapters, value.mediaCollection)

      writer.name("textColor")
      TextColor.obj().nullable().toJson(writer, customScalarAdapters, value.textColor)

      writer.name("backgroundColor")
      BackgroundColor.obj().nullable().toJson(writer, customScalarAdapters, value.backgroundColor)

      writer.name("borderColor")
      BorderColor.obj().nullable().toJson(writer, customScalarAdapters, value.borderColor)

      writer.name("text")
      Text.obj().nullable().toJson(writer, customScalarAdapters, value.text)
    }
  }

  public object MediaCollection1 : Adapter<PageQuery.MediaCollection1> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.MediaCollection1 {
      var _items: List<PageQuery.Item5?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item5.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.MediaCollection1(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.MediaCollection1,
    ): Unit {
      writer.name("items")
      Item5.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item5 : Adapter<PageQuery.Item5> {
    public val RESPONSE_NAMES: List<String> = listOf("contentType", "title", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item5 {
      var _contentType: String? = null
      var _title: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _contentType = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _title = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item5(
        contentType = _contentType,
        title = _title,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item5,
    ): Unit {
      writer.name("contentType")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.contentType)

      writer.name("title")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object TextColor : Adapter<PageQuery.TextColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.TextColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.TextColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.TextColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object BackgroundColor : Adapter<PageQuery.BackgroundColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.BackgroundColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.BackgroundColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.BackgroundColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object BorderColor : Adapter<PageQuery.BorderColor> {
    public val RESPONSE_NAMES: List<String> = listOf("hex")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.BorderColor {
      var _hex: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _hex = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.BorderColor(
        hex = _hex
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.BorderColor,
    ): Unit {
      writer.name("hex")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.hex)
    }
  }

  public object Text : Adapter<PageQuery.Text> {
    public val RESPONSE_NAMES: List<String> = listOf("json")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Text {
      var _json: Any? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _json = AnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Text(
        json = _json!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Text,
    ): Unit {
      writer.name("json")
      AnyAdapter.toJson(writer, customScalarAdapters, value.json)
    }
  }

  public object GimmicksCollection : Adapter<PageQuery.GimmicksCollection> {
    public val RESPONSE_NAMES: List<String> = listOf("items")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.GimmicksCollection {
      var _items: List<PageQuery.Item6?>? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _items = Item6.obj().nullable().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.GimmicksCollection(
        items = _items!!
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.GimmicksCollection,
    ): Unit {
      writer.name("items")
      Item6.obj().nullable().list().toJson(writer, customScalarAdapters, value.items)
    }
  }

  public object Item6 : Adapter<PageQuery.Item6> {
    public val RESPONSE_NAMES: List<String> = listOf("image", "position")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Item6 {
      var _image: PageQuery.Image? = null
      var _position: PageQuery.Position? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _image = Image.obj().nullable().fromJson(reader, customScalarAdapters)
          1 -> _position = Position.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Item6(
        image = _image,
        position = _position
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Item6,
    ): Unit {
      writer.name("image")
      Image.obj().nullable().toJson(writer, customScalarAdapters, value.image)

      writer.name("position")
      Position.obj().nullable().toJson(writer, customScalarAdapters, value.position)
    }
  }

  public object Image : Adapter<PageQuery.Image> {
    public val RESPONSE_NAMES: List<String> = listOf("title", "url")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Image {
      var _title: String? = null
      var _url: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _title = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _url = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Image(
        title = _title,
        url = _url
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Image,
    ): Unit {
      writer.name("title")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("url")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.url)
    }
  }

  public object Position : Adapter<PageQuery.Position> {
    public val RESPONSE_NAMES: List<String> = listOf("type")

    public override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters):
        PageQuery.Position {
      var _type: String? = null

      while(true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _type = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return PageQuery.Position(
        type = _type
      )
    }

    public override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: PageQuery.Position,
    ): Unit {
      writer.name("type")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.type)
    }
  }
}
